// x,y - position in %
// 0.46,0.65 - amount of space occupied by the map in %
// 1221,748 map size
// 501.04, 139.51 map beginning cordinates

export const calculateX = (x: number): number => (x / 100) * 0.43 * 1221 + 501.04;

export const calculateY = (y: number): number => (y / 100) * 0.65 * 748 + 139.51;
